/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ShopWithCeoProfile_user$ref = any;
export type ShopWithCeoDialog_user$ref = any;
export type ShopWithCeoDialog_user = {
    readonly role: string | null;
    readonly id: string;
    readonly cart: ({
        readonly id: string;
        readonly eventId: string | null;
    }) | null;
    readonly ceo: ({
        readonly id: string;
        readonly userId: string | null;
        readonly firstName: string | null;
        readonly disableJoinMyTeam: boolean | null;
        readonly lastName: string | null;
        readonly trinityDealerId: string | null;
        readonly profile: ({
            readonly image: string | null;
            readonly summary: string | null;
            readonly city: string | null;
            readonly state: string | null;
            readonly zip: string | null;
        }) | null;
    }) | null;
    readonly " $fragmentRefs": ShopWithCeoProfile_user$ref;
    readonly " $refType": ShopWithCeoDialog_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "ShopWithCeoDialog_user",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "ceoId",
                "type": "String",
                "defaultValue": null
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "cart",
                "storageKey": null,
                "args": null,
                "concreteType": "Cart",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventId",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ShopWithCeoProfile_user",
                "args": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "ceo",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "ceoId",
                        "variableName": "ceoId",
                        "type": "String"
                    }
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "userId",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "disableJoinMyTeam",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "trinityDealerId",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "profile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Profile",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "image",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "summary",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "city",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "state",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "zip",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'e916d76a1e3842a309230f84ca948697';
export default node;
